import { render, staticRenderFns } from "./TicketOrdersDetail.vue?vue&type=template&id=59d68864&scoped=true"
import script from "./TicketOrdersDetail.vue?vue&type=script&lang=js"
export * from "./TicketOrdersDetail.vue?vue&type=script&lang=js"
import style0 from "./TicketOrdersDetail.vue?vue&type=style&index=0&id=59d68864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d68864",
  null
  
)

export default component.exports